module.exports = __webpack_public_path__ + "static/media/The Vast Unfolding.381d1783.jpg";